import React from 'react';
import Arrow from '../../foundations/pictograms/arrow.svg';

export const TitleWithArrow = ({
  title,
  arrowClassName = 'h-16 w-16 ml-8 inline',
}: any) => {
  return (
    <>
      {title}
      <Arrow className={arrowClassName} />
    </>
  );
};
